// src/registered/site-admin/components/Workflow-esg/controllers/TemplateManagementController.js
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom"; 
import TemplateBuilderMainView from "../views/TemplateBuilderMainView";
import TemplateDefinitionController from "./TemplateDefinitionController";
import DisclosureSearchController from "./DisclosureSearchController";
import DisclosureSearchView from "../views/DisclosureSearchView";
import { executeWorkflowHandshake } from "../Workflow_XLS_Support";

export default function TemplateManagementController() {
  const navigate = useNavigate();
  const [template_results, setTemplateResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [infraStatus, setInfraStatus] = useState(null); 
  
  const userId = sessionStorage.getItem("SEC_USER_GUID") || "SYSTEM_USER";

  const handleInfraReady = useCallback((status) => {
    setInfraStatus(prev => {
      if (prev?.root_path === status?.root_path) return prev;
      return status;
    });
  }, []);

  const s3KeyForDiscovery = (infraStatus && selectedFile) 
    ? `${infraStatus.root_path}BaseStructure/${selectedFile.path || selectedFile.filename || selectedFile.fileName}`
    : null;

  const {
    searchTerm,
    setSearchTerm,
    isSearching,
    disclosure_results, 
    executeDisclosureSearch
  } = DisclosureSearchController(userId, s3KeyForDiscovery);

  useEffect(() => {
    const fetchInventory = async () => {
      setLoading(true);
      try {
        const response = await executeWorkflowHandshake("doorman/inventory", {
          action: "GET_INVENTORY",
          user_id: userId,
          payload: { bucket: "esg-staging-clean", prefix: "" }
        }, "Inventory");
        setTemplateResults(response?.data?.files || []);
      } catch (err) {
        setTemplateResults([]);
      } finally {
        setLoading(false);
      }
    };
    fetchInventory();
  }, [userId]);

  return (
    <div className="workflow-orchestrator pb-5">
      <TemplateBuilderMainView
        loading={loading}
        inventory={template_results} 
        selectedFile={selectedFile}
        onSelect={(file) => { setSelectedFile(file); setInfraStatus(null); }}
        
        /* 🎯 FIXED: Header 'Return to Menu' goes back to the Taxonomy Workflow Roadmap */
        onBack={() => navigate("/registered/site-admin/taxonomy-workflow")}
        
        /* 🎯 FIXED: Footer link now ALSO goes back to the Taxonomy Workflow Roadmap */
        onReturnToDashboard={() => navigate("/registered/site-admin/taxonomy-workflow")}
      >
        {selectedFile && (
          <TemplateDefinitionController
            selectedFile={selectedFile}
            onInfraReady={handleInfraReady} 
            infraStatus={infraStatus}       
          />
        )}

        {infraStatus && (
          <DisclosureSearchView
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            results={disclosure_results} 
            isSearching={isSearching}
            onSearch={executeDisclosureSearch}
          />
        )}
      </TemplateBuilderMainView>
    </div>
  );
}